/**
 * @param {Function} callback
 * @param {Number} wait
 * @returns {Function}
 */
export function debounce(callback, wait = 250) {
  let timeoutId = null;
  return (...args) => {
    window.clearTimeout(timeoutId);
    timeoutId = window.setTimeout(() => {
      callback(...args);
    }, wait);
  };
}
